/* oss-player
 * 注意事项：1.ie10及以下版本不支持hls.js和flv.js，ie9及以下版本不支持mp4，以上问题统一采用flash解决
 *           2.H5下无法实现mp4格式视频抓图功能，flash未实现视频抓图功能
 *           3.在chrome中必须将muted设置为true，video元素才能自动播放不包含音频的视频数据
 */


"use strict";

/**
 * @preserve HTML5 Shiv 3.7.3 | @afarkas @jdalton @jon_neal @rem | MIT/GPL2 Licensed
 */
!function (a, b) {
  function c(a, b) {
    var c = a.createElement("p"), d = a.getElementsByTagName("head")[0] || a.documentElement;
    return c.innerHTML = "x<style>" + b + "</style>", d.insertBefore(c.lastChild, d.firstChild)
  }

  function d() {
    var a = t.elements;
    return "string" == typeof a ? a.split(" ") : a
  }

  function e(a, b) {
    var c = t.elements;
    "string" != typeof c && (c = c.join(" ")), "string" != typeof a && (a = a.join(" ")), t.elements = c + " " + a, j(b)
  }

  function f(a) {
    var b = s[a[q]];
    return b || (b = {}, r++ , a[q] = r, s[r] = b), b
  }

  function g(a, c, d) {
    if (c || (c = b), l) return c.createElement(a);
    d || (d = f(c));
    var e;
    return e = d.cache[a] ? d.cache[a].cloneNode() : p.test(a) ? (d.cache[a] = d.createElem(a)).cloneNode() : d.createElem(a), !e.canHaveChildren || o.test(a) || e.tagUrn ? e : d.frag.appendChild(e)
  }

  function h(a, c) {
    if (a || (a = b), l) return a.createDocumentFragment();
    c = c || f(a);
    for (var e = c.frag.cloneNode(), g = 0, h = d(), i = h.length; i > g; g++) e.createElement(h[g]);
    return e
  }

  function i(a, b) {
    b.cache || (b.cache = {}, b.createElem = a.createElement, b.createFrag = a.createDocumentFragment, b.frag = b.createFrag()), a.createElement = function (c) {
      return t.shivMethods ? g(c, a, b) : b.createElem(c)
    }, a.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + d().join().replace(/[\w\-:]+/g, function (a) {
      return b.createElem(a), b.frag.createElement(a), 'c("' + a + '")'
    }) + ");return n}")(t, b.frag)
  }

  function j(a) {
    a || (a = b);
    var d = f(a);
    return !t.shivCSS || k || d.hasCSS || (d.hasCSS = !!c(a, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), l || i(a, d), a
  }

  var k, l, m = "3.7.3", n = a.html5 || {}, o = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
    p = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
    q = "_html5shiv", r = 0, s = {};
  !function () {
    try {
      var a = b.createElement("a");
      a.innerHTML = "<xyz></xyz>", k = "hidden" in a, l = 1 == a.childNodes.length || function () {
        b.createElement("a");
        var a = b.createDocumentFragment();
        return "undefined" == typeof a.cloneNode || "undefined" == typeof a.createDocumentFragment || "undefined" == typeof a.createElement
      }()
    } catch (c) {
      k = !0, l = !0
    }
  }();
  var t = {
    elements: n.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
    version: m,
    shivCSS: n.shivCSS !== !1,
    supportsUnknownElements: l,
    shivMethods: n.shivMethods !== !1,
    type: "default",
    shivDocument: j,
    createElement: g,
    createDocumentFragment: h,
    addElements: e
  };
  a.html5 = t, j(b), "object" == typeof module && module.exports && (module.exports = t)
}("undefined" != typeof window ? window : this, document);

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
if ("document" in self) {
  if (!("classList" in document.createElement("_"))) {
    (function (j) {
      "use strict";
      if (!("Element" in j)) {
        return
      }
      var a = "classList", f = "prototype", m = j.Element[f], b = Object, k = String[f].trim || function () {
        return this.replace(/^\s+|\s+$/g, "")
      }, c = Array[f].indexOf || function (q) {
        var p = 0, o = this.length;
        for (; p < o; p++) {
          if (p in this && this[p] === q) {
            return p
          }
        }
        return -1
      }, n = function (o, p) {
        this.name = o;
        this.code = DOMException[o];
        this.message = p
      }, g = function (p, o) {
        if (o === "") {
          throw new n("SYNTAX_ERR", "An invalid or illegal string was specified")
        }
        if (/\s/.test(o)) {
          throw new n("INVALID_CHARACTER_ERR", "String contains an invalid character")
        }
        return c.call(p, o)
      }, d = function (s) {
        var r = k.call(s.getAttribute("class") || ""), q = r ? r.split(/\s+/) : [], p = 0, o = q.length;
        for (; p < o; p++) {
          this.push(q[p])
        }
        this._updateClassName = function () {
          s.setAttribute("class", this.toString())
        }
      }, e = d[f] = [], i = function () {
        return new d(this)
      };
      n[f] = Error[f];
      e.item = function (o) {
        return this[o] || null
      };
      e.contains = function (o) {
        o += "";
        return g(this, o) !== -1
      };
      e.add = function () {
        var s = arguments, r = 0, p = s.length, q, o = false;
        do {
          q = s[r] + "";
          if (g(this, q) === -1) {
            this.push(q);
            o = true
          }
        } while (++r < p);
        if (o) {
          this._updateClassName()
        }
      };
      e.remove = function () {
        var t = arguments, s = 0, p = t.length, r, o = false, q;
        do {
          r = t[s] + "";
          q = g(this, r);
          while (q !== -1) {
            this.splice(q, 1);
            o = true;
            q = g(this, r)
          }
        } while (++s < p);
        if (o) {
          this._updateClassName()
        }
      };
      e.toggle = function (p, q) {
        p += "";
        var o = this.contains(p), r = o ? q !== true && "remove" : q !== false && "add";
        if (r) {
          this[r](p)
        }
        if (q === true || q === false) {
          return q
        } else {
          return !o
        }
      };
      e.toString = function () {
        return this.join(" ")
      };
      if (b.defineProperty) {
        var l = {get: i, enumerable: true, configurable: true};
        try {
          b.defineProperty(m, a, l)
        } catch (h) {
          if (h.number === -2146823252) {
            l.enumerable = false;
            b.defineProperty(m, a, l)
          }
        }
      } else {
        if (b[f].__defineGetter__) {
          m.__defineGetter__(a, i)
        }
      }
    }(self))
  } else {
    (function () {
      var b = document.createElement("_");
      b.classList.add("c1", "c2");
      if (!b.classList.contains("c2")) {
        var c = function (e) {
          var d = DOMTokenList.prototype[e];
          DOMTokenList.prototype[e] = function (h) {
            var g, f = arguments.length;
            for (g = 0; g < f; g++) {
              h = arguments[g];
              d.call(this, h)
            }
          }
        };
        c("add");
        c("remove")
      }
      b.classList.toggle("c3", false);
      if (b.classList.contains("c3")) {
        var a = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function (d, e) {
          if (1 in arguments && !this.contains(d) === !e) {
            return e
          } else {
            return a.call(this, d)
          }
        }
      }
      b = null
    }())
  }
}

var base = '/static/js/oss-player';
var ckplayerJs = base + '/ckplayer/ckplayer.js';
var ckplayerSwf = base + '/ckplayer/ckplayer.swf';
var m3u8Swf = base + '/ckplayer/m3u8.swf'; // 这里必须是绝对路径
var flvJs = base + '/flv.min.js';
var hlsJs = base + '/hls.min.js';

// 是否为移动端
var isMobile = !!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|ios|SymbianOS)/i);
// 是否支持video标签
var isSupportVideo = document.createElement('video');
// 是否支持video标签和addEventListener方法（主要为了区别ie8）
var isModernBrowser = !!isSupportVideo.canPlayType && !!window.addEventListener;
// 是否能使用video原生播放hls，目前只有safari可以支持原生video播放。
var isNativeSupportHls = isModernBrowser && isSupportVideo.canPlayType('application/vnd.apple.mpegURL');
// ie版本
var ieVersion = checkIeVersion();

// IE版本
function checkIeVersion() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6;// IE版本<=7
    }
  } else if (isEdge) {
    return 12; // edge
  } else if (isIE11) {
    return 11; // IE11
  } else {
    return -1;// 不是ie浏览器
  }
}

// 动态加载js
var loadedjsElementFilePaths = []
function requireJs(filePath, callback) {
  // 检测文件是否已加载
  if (loadedjsElementFilePaths.indexOf(filePath) !== -1) {
    callback()
    return
  }

  var jsElement = document.createElement('script')
  jsElement.setAttribute('type', 'text/javascript')
  jsElement.setAttribute('src', filePath)
  document.getElementsByTagName('head')[0].appendChild(jsElement)
  if (jsElement.readyState) { // IE
    jsElement.onreadystatechange = function () {
      if (jsElement.readyState === 'loaded' || jsElement.readyState === 'complete') {
        jsElement.onreadystatechange = null
        loadedjsElementFilePaths.push(filePath)
        callback()
      }
    }
  } else {
    jsElement.onload = function () {
      loadedjsElementFilePaths.push(filePath)
      callback()
    }
  }
}

//
var OssPlayer = function (playParams) {
  if (!isModernBrowser) {
    throw new Error('不支持ie8等低版本浏览器');
    return;
  }

  // 定义播放配置项
  this.opt = {};
  this.opt.mode = 0;  //模式，0-直播,1-点播
  this.opt.sources = [];
  this.opt.autoPlay = true; // playParams.autoPlay;
  this.opt.checkEnabled = true; // playParams.checkEnabled;
  this.opt.audioEnabled = false; // playParams.audioEnabled;
  this.handlers = {};
  this.videoId = playParams.videoId;
  this.video = document.getElementById(playParams.videoId);
  this.video.wrapper = this;
  this.video.muted = !this.opt.audioEnabled;
  this.playProtocol = 1;  // 播放协议，0-hls,1-flv,2-rtmp,3-fmp4
  this.playerKind = 1;  // 播放器种类，0-hls.js,1-flv.js,2-flash,3-video
  this.currentSource = '';
  this.startTimeMs = (new Date).getTime();
  this.image = null;
  this.checkTimer = null;
  this.canCheck = false;

  //
  this.opt.sources.push(playParams.source);
  this.tryPlay(playParams.source);

  // 启动视频检测
  if (ieVersion < 0 || ieVersion > 9) {  // ie最低版本为10
    this.checkTimer = setInterval(this.onCheck, 10000, this);
  }
};

//
OssPlayer.prototype.tryPlay = function (source) {
  console.log("开始尝试播放，播放源为：");
  console.log(source);

  var _this = this;
  // HLS地址
  if (/\.m3u8/.test(source)) {
    // 如果是手机浏览器环境,或者原生支持HLS播放的,直接使用video标签播放
    // 否则尝试使用hls.js播放
    _this.playProtocol = 0;
    if (isMobile || isNativeSupportHls) {
      console.log('使用原生video');
      _this.playerKind = 3;
      // _this.video.offsetWidth = this.video.offsetWidth * 9 / 16;
      _this.video.src = source;
      this.initVideoEvent();
      if (_this.opt.autoPlay) {
        _this.video.play();
      }
    } else {
      // hls.js要求ie最低版本为11
      if (ieVersion < 0 || ieVersion > 10) {
        _this.playerKind = 0;
        this.initVideoEvent();
        requireJs(hlsJs, function () {
          console.log('使用hls.js播放');
          _this.initHls(source);
        });
      } else {
        _this.playerKind = 2;
        requireJs(ckplayerJs, function () {
          _this.initCkPlayer(source);
        });
      }
    }
  } else if (/flv/.test(source)) {
    _this.playProtocol = 1;
    // flv.js要求ie最低版本为11
    if (ieVersion < 0 || ieVersion > 10) {
      _this.playerKind = 1;
      this.initVideoEvent();
      requireJs(flvJs, function () {
        console.log("使用flv.js播放");
        _this.initflv(source);
      });
    } else {
      _this.playerKind = 2;
      requireJs(ckplayerJs, function () {
        _this.initCkPlayer(source);
      });
    }
  } else if (/^rtmp:/.test(source)) {
    _this.playProtocol = 2;
    _this.playerKind = 2;
    if (isMobile) {
      console.log('手机不支持rtmp格式播放');
      return;
    } else {
      requireJs(ckplayerJs, function () {
        _this.initCkPlayer(source);
      });
    }
  } else if (/\.mp4/.test(source)) {
    _this.playProtocol = 3;
    // mp4要求ie最低版本为9,但视频检测ie最低版本为10
    if (ieVersion < 0 || ieVersion > 9) {
      console.log('使用原生video');
      _this.playerKind = 3;
      // _this.video.offsetWidth = this.video.offsetWidth * 9 / 16;
      _this.video.src = source;
      _this.video.type = 'video/mp4';
      this.initVideoEvent();
      if (_this.opt.autoPlay) {
        _this.video.play();
      }
    } else {
      _this.playerKind = 2;
      requireJs(ckplayerJs, function () {
        _this.initCkPlayer(source);
      });
    }
  } else {
    console.log("没有可用的播放器");
  }
};

// 初始化hls.js
OssPlayer.prototype.initHls = function (source) {
  if (!Hls.isSupported()) {
    console.log("浏览器不支持hls.js播放");
    throw new Error('浏览器不支持hls.js播放');
    return;
  }

  var _this = this;
  var hls = new Hls({defaultAudioCodec: 'mp4a.40.2'}); // 默认使用 AAC LC 音频编码
  hls.loadSource(source);
  hls.attachMedia(this.video);
  hls.on(Hls.Events.MANIFEST_PARSED, function () {
    if (_this.opt.autoPlay) {
      _this.video.play();
    }
  });
  hls.on(Hls.Events.ERROR, function (event, data) {
    if (data.fatal) {
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          // try to recover network error
          console.log("fatal network error encountered, try to recover");
          hls.startLoad();
          break;
        case Hls.ErrorTypes.MEDIA_ERROR:
          console.log("fatal media error encountered, try to recover");
          hls.recoverMediaError();
          break;
        default:
          // cannot recover
          break;
      }
    }
  });

  this.hlsPlayer = hls;
  this.currentSource = source;
};

//
OssPlayer.prototype.initflv = function (source) {
  if (!flvjs.isSupported()) {
    console.log("浏览器不支持flv播放");
    throw new Error('浏览器不支持flv播放');
    return;
  }

  var hasControls = this.video.getAttribute('controls');
  if (!hasControls) {
    this.video.setAttribute('controls', true);
  }

  //
  var flvPlayer2 = flvjs.createPlayer({
    type: 'flv',
    url: source,
    isLive: true,  //开启直播
    hasAudio: this.opt.audioEnabled,  // 是否开启声音
    cors: true,  // 开启跨域访问
  }, {
    enableStashBuffer: false,
    lazyLoad: true,
    lazyLoadMaxDuration: 1,
    lazyLoadRecoverDuration: 1,
    deferLoadAfterSourceOpen: false,
    statisticsInfoReportInterval: 1,
    fixAudioTimestampGap: false,
    autoCleanupSourceBuffer: true,
    autoCleanupMaxBackwardDuration: 5,
    autoCleanupMinBackwardDuration: 2,
  });

  flvPlayer2.attachMediaElement(this.video);
  flvPlayer2.load();
  if (this.opt.autoPlay) {
    flvPlayer2.play();
  }

  this.flvPlayer = flvPlayer2;
  this.currentSource = source;
};

// 初始化ckplayer
OssPlayer.prototype.initCkPlayer = function (source) {
  console.log('ckplayer初始化');

  var _this = this;
  var events = {
    'play': function () {
      console.log('play');
      _this.startTimeMs = (new Date).getTime();
      // _this.emit('play');
    },
    'pause': function () {
      // _this.emit('pause');
    },
    'ended': function () {
      console.log('ended');
      if (_this.opt.mode === 0) { // 直播
        _this.restart();
      }
      // _this.emit('ended');
    },
    'error': function () {
      console.log('error');
      // _this.emit('error');
    }
  };
  window.ckplayer_status = function () {
    events[arguments[0]] && events[arguments[0]]();
  };

  // 新增相同id的div标签，然后删除video标签
  var videoFlashWidth = this.video.offsetWidth;
  var videoFlashHeight = this.video.offsetHeight;
  this.videoFlash = document.createElement('DIV');
  this.video.parentNode.replaceChild(this.videoFlash, this.video);
  this.video = this.videoFlash;
  this.video.id = this.videoId;

  var flashvars = null;
  // 如果rtmp服务器环境设置了视频暂停则断开链接
  // 需要修改ckplayer.js  setup参数第30个值
  // 在播放暂停后点击播放是否采用重新链接的方式
  if (/^rtmp/.test(source)) {
    flashvars = {
      f: source,
      c: 0,
      p: this.opt.autoPlay ? 1 : 0,
      i: this.opt.poster,
      lv: 1,
      loaded: 'loadHandler'
    };
  } else if (/\.m3u8/.test(source)) {
    flashvars = {
      s: 4, // 4-使用swf视频流插件播放
      f: m3u8Swf,
      a: source,
      c: 0,  // 0-使用ckplayer.js的配置 1-使用ckplayer.xml的配置
      lv: 1, // 1-直播 0-普通方式
      p: this.opt.autoPlay ? 1 : 0,   // 1-默认播放 0-默认暂停
      i: this.opt.poster,
      loaded: 'loadHandler'
    };
  } else {
    flashvars = {
      f: source,
      c: 0,
      p: 1,
      loaded: 'loadHandler'
    };
  }

  var params = {bgcolor: '#FFF', allowFullScreen: true, allowScriptAccess: 'always', wmode: 'transparent'};
  this.flashId = this.videoId + '-flash';
  window.CKobject.embedSWF(ckplayerSwf, this.videoId, this.flashId, videoFlashWidth, videoFlashHeight, flashvars, params);
  // window.CKobject.embedSWF(ckplayerSwf, this.videoId, this.flashId, '100%', '100%', flashvars, params);
  this.currentSource = source;
};

//
OssPlayer.prototype.play = function () {
  //
  console.log("启动播放" + this.currentSource);

  if (this.playerKind === 2 && !!window['CKobject']) {
    CKobject.getObjectById(this.flashId).videoPlay();
  } else if (!!this.video) { // video播放
    if (this.playerKind === 0 && !!this.hlsPlayer) {
      this.hlsPlayer.startLoad();
      this.video.play();
    } else if (this.playerKind === 1 && !!this.flvPlayer) {
      this.flvPlayer.play();
    } else { // 其他开始播放使用原生video
      this.video.play();
    }
  } else {
  }
};

//
OssPlayer.prototype.pause = function () {
  // 暂停检测
  this.canCheck = false;

  //
  console.log("暂停播放" + this.currentSource);

  if (this.playerKind === 2 && !!window['CKobject']) {
    CKobject.getObjectById(this.flashId).videoPause();
  } else if (!!this.video) {
    if (this.playerKind === 0 && !!this.hlsPlayer) {
      // 通过暂停停止播放
      this.video.pause();
    } else if (this.playerKind === 1 && !!this.flvPlayer) {
      this.flvPlayer.pause();
    } else {
      this.video.pause();
    }
  }
};

//
OssPlayer.prototype.stop = function () {
  // 停止检测
  this.canCheck = false;
  this.image = null;
  if (this.checkTimer != null) {
    clearInterval(this.checkTimer);
    this.checkTimer = null;
  }

  // 停止播放
  console.log("停止播放" + this.currentSource);
  this.currentSource = '';

  if (this.playerKind === 2 && !!window['CKobject']) {
    CKobject.getObjectById(this.flashId).videoClear();
    // this.video.remove();
  } else if (!!this.video) {
    if (this.playerKind === 0 && !!this.hlsPlayer) {   // hls停止依赖this.hls
      // 通过暂停停止播放
      this.video.pause();
      this.video.src = ""
      // 停止取流
      this.hlsPlayer.stopLoad();
      this.hlsPlayer.destroy();
      this.hlsPlayer = null;
    } else if (this.playerKind === 1 && !!this.flvPlayer) {
      this.flvPlayer.pause();
      this.flvPlayer.unload();
      this.flvPlayer.detachMediaElement();
      this.flvPlayer.destroy();
      this.flvPlayer = null;
    } else {
      // 通过暂停停止播放
      this.video.pause();
      this.video.src = ""
    }
  }
};

//
OssPlayer.prototype.restart = function () {

  if (this.getActive()) {
    this.stop();
  }

  if (this.opt.sources.length <= 0) {
    return;
  }

  var source = this.opt.sources[0];
  console.log("开始尝试播放，播放源为：");
  console.log(source);

  var _this = this;
  if (_this.playerKind === 0) { // hls.js
    console.log('使用hls.js播放');
    _this.initHls(source);
  } else if (_this.playerKind === 1) { // flv.js
    console.log("使用flv.js播放");
    _this.initflv(source);
  } else if (_this.playerKind === 2) { // flash
    if (isMobile) {
      console.log('手机不支持rtmp格式播放');
      return;
    } else {
      _this.initCkPlayer(source);
    }
  } else if (_this.playerKind === 3) { // video
    console.log('使用原生video');
    _this.video.src = source;
    if (_this.opt.autoPlay) {
      _this.video.play();
    }
  } else {
    console.log("没有可用的播放器");
  }

  // 启动视频检测
  if (ieVersion < 0 || ieVersion > 9) {  // ie最低版本为10
    this.checkTimer = setInterval(this.onCheck, 15000, this);
  }
};

//
OssPlayer.prototype.capturePiture = function () {
  //
  console.log("抓图");

  if (this.playerKind === 2 && !!window['CKobject']) {
    alert('flash播放模式不支持视频抓图功能！')
    /*        CKobject.getObjectById(this.flashId).addListener('screenshot', function (obj) {
                if (obj != null) { //监听回调 保存数据
                    var a = document.createElement("a");
                    a.download = '图片' + (new Date).getTime() + '.png';// 设置下载的文件名，默认是'下载'
                    a.href = obj.base64;
                    document.body.appendChild(a);
                    a.click();
                    a.remove(); // 下载之后把创建的元素删除
                }
            });
            CKobject.getObjectById(this.flashId).screenShot('video',false,'视频截图');*/
  } else if (!!this.video) { // video播放
    var canvas = document.createElement("canvas");
    canvas.width = this.video.videoWidth;
    canvas.height = this.video.videoHeight;
    canvas.getContext('2d').drawImage(this.video, 0, 0, canvas.width, canvas.height);

    try {
      var image = canvas.toDataURL("image/png");
      var a = document.createElement("a");
      a.download = '图片' + (new Date).getTime() + '.png';// 设置下载的文件名，默认是'下载'
      a.href = image;
      document.body.appendChild(a);
      a.click();
      a.remove(); // 下载之后把创建的元素删除
    } catch (e) {
      console.log(e.message);
    }
  } else {
  }
};

//
OssPlayer.prototype.getActive = function () {

  if (this.playerKind === 2 && !!window['CKobject']) {
    return true;
  } else if (!!this.video) {
    if (this.playerKind === 0 && !!this.hlsPlayer) {   // hls停止依赖this.hls
      return true;
    } else if (this.playerKind === 1 && !!this.flvPlayer) {
      return true;
    } else if (this.playerKind === 3 && this.video.src !== '') {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

//
OssPlayer.prototype.initVideoEvent = function () {
  var events = {
    'loadstart': function (e) {
      // console.log('loadstart...当浏览器开始查找音频/视频时...');
      // this.emit('loadstart', e);
    },
    'durationchange': function (e) {
      // console.log('durationchange...当音频/视频的时长已更改时...');
      // this.emit('durationchange', e);
    },
    'loadedmetadata': function (e) {
      // console.log('loadedmetadata...当浏览器已加载音频/视频的元数据时...');
      // this.emit('loadedmetadata', e);
    },
    'loadeddata': function (e) {
      console.log('loadeddata...当浏览器已加载音频/视频的当前帧时...');
      // this.emit('loadeddata', e);
    },
    'progress': function (e) {
      // console.log('progress...当浏览器正在下载音频/视频时...');
      // this.emit('progress', e);
    },
    'canplay': function (e) {
      // console.log('canplay...当浏览器可以播放音频/视频时...');
      // this.emit('canplay', e);
    },
    'canplaythrough': function (e) {
      // console.log('canplaythrough...当浏览器可在不因缓冲而停顿的情况下进行播放时...');
      // this.emit('canplaythrough', e);
    },
    'abort': function (e) {
      console.log('abort...当音频/视频的加载已放弃时...');
      // this.emit('abort', e);
    },
    'emptied': function (e) {
      // console.log('emptied...当目前的播放列表为空时...');
      // this.emit('emptied', e);
    },
    'ended': function (e) {
      console.log('ended...当目前的播放列表已结束时...');
      // this.emit('ended', e);
    },
    'pause': function (e) {
      console.log('pause...当音频/视频已暂停时...');
      // this.emit('pause', e);
    },
    'play': function (e) {
      console.log('play...当音频/视频已开始或不再暂停时...');
      if (e && e.target && e.target.wrapper) {
        e.target.wrapper.startTimeMs = (new Date).getTime();
        e.target.wrapper.canCheck = true;

        // this.emit('play', e);
      }
    },
    'playing': function (e) {
      // console.log('playing...当音频/视频在已因缓冲而暂停或停止后已就绪时...');
      // this.emit('playing', e);
    },
    'ratechange': function (e) {
      console.log('ratechange...当音频/视频的播放速度已更改时...');
      // this.emit('ratechange', e);
    },
    'seeked': function (e) {
      console.log('seeked...当用户已移动/跳跃到音频/视频中的新位置时...');
      // this.emit('seeked', e);
    },
    'seeking': function (e) {
      // console.log('seeking...当用户开始移动/跳跃到音频/视频中的新位置时...');
      // this.emit('seeking', e);
    },
    'stalled': function (e) {
      console.log('stalled...当浏览器尝试获取媒体数据，但数据不可用时...');
      // this.emit('stalled', e);
    },
    'suspend': function (e) {
      console.log('suspend...当浏览器刻意不获取媒体数据时...');
      // this.emit('suspend', e);
    },
    'timeupdate': function (e) {
      //me.log('timeupdate...当目前的播放位置已更改时...');
      // this.emit('timeupdate', e);
    },
    'volumechange': function (e) {
      console.log('volumechange...当音量已更改时...');
      // this.emit('volumechange', e);
    },
    'waiting': function (e) {
      // console.log('waiting...当视频由于需要缓冲下一帧而停止...');
      // this.emit('waiting', e);
    },
    'error': function (e) {
      if (e && e.target && e.target.error) {
        console.log('error(' + e.target.error.code + "," + e.target.error.message + ')...当在音频/视频加载期间发生错误时...');
      //   if (e.target.error.code === 3) {
      //     e.target.wrapper.restart();
      //   }
      //   // this.emit('error', e);
      }
    }
  };
  for (let i in events) {
    this.video.addEventListener(i, events[i], false);
  }

  // ios11Hack(this.video);
};

//
OssPlayer.prototype.onCheck = function (player) {
  // console.log('on check');
  if (player.opt.checkEnabled && player.canCheck) {
    if (player.playerKind === 2) { //不检测flash播放
      return;
    }

    // console.log('ready check');
    var restart = false;
    //检测播放延时
    if (!restart) {
      const bufCount = player.video.buffered.length;
      if (bufCount > 0) {
        //比较最后一帧缓冲时间与当前时间，大于某一阈值时就跳帧
        const delay = player.video.buffered.end(bufCount - 1) - player.video.currentTime;
        if (delay >= 5) {  //延时大于等于5秒
          console.log("delay exceed max:" + delay * 1000 + "ms");
          player.video.currentTime = player.video.buffered.end(bufCount - 1);
        }
      }
    }

    // 检测两幅画面变化
    if (!restart) {
      var canvas = document.createElement("canvas");
      canvas.width = player.video.videoWidth;
      canvas.height = player.video.videoHeight;
      canvas.getContext('2d').drawImage(player.video, 0, 0, canvas.width, canvas.height);

      var image = null;
      try {
        image = canvas.toDataURL("image/png");
      } catch (e) {
        console.log(e.message);
        return;
      }

      if (player.image != null) {
        if (image == player.image) {
          restart = true;
          console.log("image not changed");
        } else {
          // console.log("image has changed");
        }
      }
      player.image = image;
    }
    // console.log('check finished');

    if (restart) {
      // console.log('ready restart');
      player.restart();
      // console.log('restart finished');
    }
  }
};

// 创建对象
function createPlayer(playParams) {
  return new OssPlayer(playParams)
}

// 导出函数
module.exports = {createPlayer};



//////////////////
// WEBPACK FOOTER
// ./static/js/oss-player/oss-player.js
// module id = z7TJ
// module chunks = 2